import styled from "styled-components/macro";

export const Container = styled.div`
  max-width: 872px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;    
`

export const Content = styled.div``

export const Paragraph = styled.p`
  font-size: 18px;
  line-height: 140%;
  margin-bottom: 18px;

  @media (max-width: 979px) {
    font-size: 16px;
  }
`

